import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/home_1.png'
import _imports_1 from '../assets/home_2.png'
import _imports_2 from '../assets/home_3.png'
import _imports_3 from '../assets/home_4.png'
import _imports_4 from '../assets/left.png'
import _imports_5 from '../assets/right.png'
import _imports_6 from '../assets/01.jpg'
import _imports_7 from '../assets/02.jpg'
import _imports_8 from '../assets/03.jpg'
import _imports_9 from '../assets/diannao.png'
import _imports_10 from '../assets/fun1.png'
import _imports_11 from '../assets/fun2.png'
import _imports_12 from '../assets/fun3.png'
import _imports_13 from '../assets/fun4.png'
import _imports_14 from '../assets/fun5.png'
import _imports_15 from '../assets/fun6.png'


const _withScopeId = n => (_pushScopeId("data-v-7a4bc4e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","overflow-x":"hidden"} }
const _hoisted_2 = { class: "topic" }
const _hoisted_3 = { class: "card-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title t-c" }, "全真考试题库·紧扣考试大纲", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f16 c66 t-c" }, "全面覆盖了考试大纲的知识点和重点，确保考生能够接触到与真实考试高度一致的题型和难度", -1))
const _hoisted_6 = { class: "d-f topic_" }
const _hoisted_7 = { class: "c33 f20 tab t-c" }
const _hoisted_8 = { class: "content p-r" }
const _hoisted_9 = { class: "c00 f28 f-w" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c3d f16 contents" }, "信息考试系统的题库系统，涵盖多模块试题，含选择题及Windows、Word、Excel、PPT、IE等操作题，满足多样考试需求，实现高效组卷与管理。", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f16 t-c c49 con_" }, [
  /*#__PURE__*/_createElementVNode("div", null, "单项选择"),
  /*#__PURE__*/_createElementVNode("div", null, "Windows操作题"),
  /*#__PURE__*/_createElementVNode("div", null, "Excel操作题"),
  /*#__PURE__*/_createElementVNode("div", null, "IE浏览器"),
  /*#__PURE__*/_createElementVNode("div", null, "Word操作题"),
  /*#__PURE__*/_createElementVNode("div", null, "……")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "content p-r" }
const _hoisted_14 = { class: "c00 f28 f-w" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c3d f16 contents" }, "视频教学模块直观地演示操作技巧，高效备考，轻松掌握考点。学生可以在操作过程中获得详细步骤指导和视频演示。帮助学生查漏补缺，解决学习中的难点和痛点。", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f16 t-c c49 con_" }, [
  /*#__PURE__*/_createElementVNode("div", null, "步骤详析"),
  /*#__PURE__*/_createElementVNode("div", null, "自学指引"),
  /*#__PURE__*/_createElementVNode("div", null, "视频辅导"),
  /*#__PURE__*/_createElementVNode("div", null, "难点攻克"),
  /*#__PURE__*/_createElementVNode("div", null, "查漏补缺"),
  /*#__PURE__*/_createElementVNode("div", null, "……")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "content p-r" }
const _hoisted_19 = { class: "c00 f28 f-w" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c3d f16 contents" }, "模拟考场，精准还原考试环境，助力考生实战演练，高效备考，它不仅能够帮助考生提前适应真实的考试环境，还能够全面考核考生的能力、提供即时的反馈与评估，学生可居家自评分数。", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f16 t-c c49 con_" }, [
  /*#__PURE__*/_createElementVNode("div", null, "环境预演"),
  /*#__PURE__*/_createElementVNode("div", null, "能力全检"),
  /*#__PURE__*/_createElementVNode("div", null, "即时反馈"),
  /*#__PURE__*/_createElementVNode("div", null, "个性辅导"),
  /*#__PURE__*/_createElementVNode("div", null, "精准评估"),
  /*#__PURE__*/_createElementVNode("div", null, "……")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "content p-r" }
const _hoisted_24 = { class: "c00 f28 f-w" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c3d f16 contents" }, "系统智能记录做题情况，对已作答、部分作答和未作答的题目分别标记，帮助学生清晰了解自己的练习情况。帮助考生更有效地识别和纠正自己的错误，从而提高学习效率和学习成绩。", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f16 t-c c49 con_" }, [
  /*#__PURE__*/_createElementVNode("div", null, "智能记录"),
  /*#__PURE__*/_createElementVNode("div", null, "分类清晰"),
  /*#__PURE__*/_createElementVNode("div", null, "错题识别"),
  /*#__PURE__*/_createElementVNode("div", null, "纠正高效"),
  /*#__PURE__*/_createElementVNode("div", null, "成绩提升"),
  /*#__PURE__*/_createElementVNode("div", null, "……")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "environment p-r" }
const _hoisted_29 = { class: "card-wrap p-r" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title t-c" }, "模拟真实考试环境", -1))
const _hoisted_31 = { class: "cff f26 t-c" }
const _hoisted_32 = { class: "cff f26 t-c" }
const _hoisted_33 = { class: "cff f26 t-c" }
const _hoisted_34 = {
  style: {"height":"55px"},
  class: "f16 c7b t-c"
}
const _hoisted_35 = {
  style: {"height":"55px"},
  class: "f16 c7b t-c"
}
const _hoisted_36 = {
  style: {"height":"55px"},
  class: "f16 c7b t-c"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a left",
  src: _imports_4
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a right",
  src: _imports_5
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-a diannao",
  src: _imports_9
}, null, -1))
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"function\" data-v-7a4bc4e6><div class=\"card-wrap\" data-v-7a4bc4e6><div class=\"title t-c\" data-v-7a4bc4e6>全真模拟·练习题库</div><div class=\"f16 c66 t-c tips\" data-v-7a4bc4e6>信考百分是一个高效、全面、便捷的考试信息测评平台，提供丰富资源与模拟环境，助力学生精通信息技术，提升应试实力。</div><div class=\"funs\" data-v-7a4bc4e6><div class=\"fun t-c\" data-v-7a4bc4e6><img src=\"" + _imports_10 + "\" alt=\"\" data-v-7a4bc4e6><div class=\"c00 f18 f-w\" data-v-7a4bc4e6>题型丰富多样</div><div class=\"c66 f14 tips_\" data-v-7a4bc4e6>涵盖多模块试题，含选择题及Windows、Word、Excel、PPT、IE等操作题。</div></div><div class=\"fun t-c\" data-v-7a4bc4e6><img src=\"" + _imports_11 + "\" alt=\"\" data-v-7a4bc4e6><div class=\"c00 f18 f-w\" data-v-7a4bc4e6>智能测评反馈</div><div class=\"c66 f14 tips_\" data-v-7a4bc4e6>练习过程中随时提交，即时分析答案，智能评估，给予准确反馈。</div></div><div class=\"fun t-c\" data-v-7a4bc4e6><img src=\"" + _imports_12 + "\" alt=\"\" data-v-7a4bc4e6><div class=\"c00 f18 f-w\" data-v-7a4bc4e6>个性化学习</div><div class=\"c66 f14 tips_\" data-v-7a4bc4e6>根据用户注册资料，提供相关课程的试题，紧扣信息考试大纲。</div></div><div class=\"fun t-c\" data-v-7a4bc4e6><img src=\"" + _imports_13 + "\" alt=\"\" data-v-7a4bc4e6><div class=\"c00 f18 f-w\" data-v-7a4bc4e6>模拟真实环境</div><div class=\"c66 f14 tips_\" data-v-7a4bc4e6>精准还原考试环境， 全面考核，助力学生居家实战测评。</div></div><div class=\"fun t-c\" data-v-7a4bc4e6><img src=\"" + _imports_14 + "\" alt=\"\" data-v-7a4bc4e6><div class=\"c00 f18 f-w\" data-v-7a4bc4e6>智能组卷评估</div><div class=\"c66 f14 tips_\" data-v-7a4bc4e6>根据用户答题记录，智能生成试卷，灵活测评，并形成测评报告。</div></div><div class=\"fun t-c\" data-v-7a4bc4e6><img src=\"" + _imports_15 + "\" alt=\"\" data-v-7a4bc4e6><div class=\"c00 f18 f-w\" data-v-7a4bc4e6>多模式练习</div><div class=\"c66 f14 tips_\" data-v-7a4bc4e6>用户在使用过程中可根据需要，自由练习或模拟练习。</div></div></div></div></div>", 1)

import top from "./top.vue";
    import bottom from "./bottom.vue";
    import {lastVersionReleases,} from "@/axios/index";
    import { ref, onMounted,onUnmounted,nextTick } from "vue";
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';
    import 'swiper/css/bundle';
    import 'swiper/css/navigation';
    import 'swiper/css/effect-fade';
    import 'swiper/css/pagination'
    import { Pagination,Navigation,Autoplay } from 'swiper/modules';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

    const navigation = ref({
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    });
    const releasess = ref();
    const releasess_ = ref();
    const lastVersionReleasess = async () => {
        const { data }: any = await lastVersionReleases({});
        if (data.code == 200) {
            releasess.value = data.data.url
            releasess_.value =data.data.url2
        };
    };
    const times =ref(null);
    times.value = setInterval(() => {
        tabs();
    }, 5000);
    const tabs = () => {
        if(tab.value == 3){
            tab.value = 0
            return
        }
        tab.value=tab.value+1
    };
    const modules = [Pagination,Navigation,Autoplay]
    const hovetab = (index) => {
        clearInterval(times.value)
        times.value = null
        tab.value = index
    };
    const handtab = () => {
        if(times.value == null){
            times.value = setInterval(() => {
                tabs();
            }, 5000);
        }
    };
    const activeIndex = ref(0);
    const SlideChange = (e) => {
        activeIndex.value = e.activeIndex
    };
    const prevEl = (e,f) => {
        console.log(e,f);
    };
    const nextEl = () => {
    };
    const tab = ref<Number>(0);
    const screenWidth = ref(window.innerWidth);
        
    const handleResize = () => {
    screenWidth.value = window.innerWidth;
    };
    onMounted(() => {
        lastVersionReleasess()
        setInterval(() => {
            lastVersionReleasess();
        }, 60000);
        window.addEventListener('resize', handleResize);
        nextTick(() => {
            document.oncontextmenu = new Function("event.returnValue=false");
            document.onselectstart = new Function("event.returnValue=false");
            document.addEventListener("keydown", function (e) {
                if (e.key == "F12") {
                e.preventDefault(); // 如果按下键F12,阻止事件
                }
            });
        })
    });
    onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
    });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(top, {
      releasess: releasess.value,
      releasess_: releasess_.value
    }, null, 8, ["releasess", "releasess_"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (hovetab(0))),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (handtab())),
              class: _normalizeClass([tab.value == 0?'tabs cff':''])
            }, "题库系统", 34),
            _createElementVNode("div", {
              onMouseover: _cache[2] || (_cache[2] = ($event: any) => (hovetab(1))),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (handtab())),
              class: _normalizeClass([tab.value == 1?'tabs cff':''])
            }, "视频教学", 34),
            _createElementVNode("div", {
              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (hovetab(2))),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (handtab())),
              class: _normalizeClass([tab.value == 2?'tabs cff':''])
            }, "模拟考场", 34),
            _createElementVNode("div", {
              onMouseover: _cache[6] || (_cache[6] = ($event: any) => (hovetab(3))),
              onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (handtab())),
              class: _normalizeClass([tab.value == 3?'tabs cff':''])
            }, "错题分析", 34)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", _hoisted_9, "题库系统", 512), [
              [_vShow, screenWidth.value > 1200]
            ]),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ], 512), [
            [_vShow, tab.value == 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("div", _hoisted_14, "视频教学", 512), [
              [_vShow, screenWidth.value > 1200]
            ]),
            _hoisted_15,
            _hoisted_16,
            _hoisted_17
          ], 512), [
            [_vShow, tab.value == 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", _hoisted_19, "模拟考场", 512), [
              [_vShow, screenWidth.value > 1200]
            ]),
            _hoisted_20,
            _hoisted_21,
            _hoisted_22
          ], 512), [
            [_vShow, tab.value == 2]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("div", _hoisted_24, "错题分析", 512), [
              [_vShow, screenWidth.value > 1200]
            ]),
            _hoisted_25,
            _hoisted_26,
            _hoisted_27
          ], 512), [
            [_vShow, tab.value == 3]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _withDirectives(_createElementVNode("div", _hoisted_31, "全真题库", 512), [
          [_vShow, activeIndex.value == 0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_32, "个性化选择", 512), [
          [_vShow, activeIndex.value == 2]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_33, "激活帮助", 512), [
          [_vShow, activeIndex.value == 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_34, "信息考试全真题库的内容广泛且多样，涵盖多个模块多种题型，让您的测评更系统、更全面", 512), [
          [_vShow, activeIndex.value == 0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_35, "适用于初中学业水平考试、会考、高考等信息技术考试。根据考生的必修科目和选修科目，可自由勾选科目进行组卷，定制您的专属测评系统。", 512), [
          [_vShow, activeIndex.value == 2]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_36, "旨在为用户提供便捷、高效的软件激活服务，确保用户能够顺利使用软件的全部功能。更好的服务", 512), [
          [_vShow, activeIndex.value == 1]
        ]),
        _createElementVNode("div", {
          class: "swiper-button-prev swiper-button",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (prevEl(_ctx.item, _ctx.index)), ["stop"]))
        }, _hoisted_38),
        _createElementVNode("div", {
          class: "swiper-button-next swiper-button",
          onClick: _withModifiers(nextEl, ["stop"])
        }, _hoisted_41, 8, _hoisted_39)
      ]),
      _createVNode(_unref(Swiper), {
        onSlideChange: SlideChange,
        autoplay: { delay: 2500 },
        modules: modules,
        "slides-per-view": 1,
        "space-between": 96,
        "centered-slides": true,
        navigation: navigation.value,
        pagination: { clickable: true }
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SwiperSlide), null, {
            default: _withCtx(() => [
              _hoisted_42
            ]),
            _: 1
          }),
          _createVNode(_unref(SwiperSlide), null, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          }),
          _createVNode(_unref(SwiperSlide), null, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          }),
          _hoisted_45
        ]),
        _: 1
      }, 8, ["navigation"]),
      _hoisted_46
    ]),
    _hoisted_47,
    _createVNode(bottom, {
      releasess: releasess.value,
      releasess_: releasess_.value
    }, null, 8, ["releasess", "releasess_"])
  ]))
}
}

})